/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { GmaoPieChartController } from './GmaoPieChart';

class GmaoActionRequestsByCauseChartController extends GmaoPieChartController {
    /** @ngInject */
    constructor($log, configuration, $translate) {
        super($log, configuration);
        this.$translate = $translate;
        this.$log.debug('Controller \'GmaoActionRequestsByCauseChart\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.chartData = this.data;
    }
}

export const gmaoActionRequestsByCauseChartComponent = {
    controller: GmaoActionRequestsByCauseChartController,
    template: require('./gmao-chart.html'),
    bindings: {
        data: '='
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/statistics/component/GmaoActionRequestsByCauseChart.js